<template>
  <audio ref="call-sound" loop>
    <source src="/audio/call.ogg" type="audio/ogg" />
    <source src="/audio/call.mp3" type="audio/mpeg" />
    Your browser does not support the audio element.
  </audio>
</template>
<script>
export default {
  mounted () {
    this.$refs['call-sound'].play()
  }
}
</script>
